import { AnyAction } from 'redux'

type ListenMessageProps<T extends AnyAction> = {
  sourceWindow?: Window | null
  onMessage: (action: T) => void | Promise<void>
  whitelist?: AnyAction[]
  allowSameOrigin?: boolean
}
export const listenMessage = <T extends AnyAction>({
  onMessage,
  whitelist,
  sourceWindow,
  allowSameOrigin = true,
}: ListenMessageProps<T>) => {
  const handleMessage = (event: MessageEvent<AnyAction>) => {
    const isSameOrigin = event.origin === window.location.origin
    const isCorrectIframe = sourceWindow ? event.source === sourceWindow : true

    const isAction =
      event.data && typeof event.data === 'object' && 'type' in event.data

    const isWhitelisted = whitelist
      ? whitelist.some(({ type }) => type === event.data.type || type === '*')
      : true

    if (
      (allowSameOrigin || !isSameOrigin) &&
      isCorrectIframe &&
      isAction &&
      isWhitelisted
    ) {
      void onMessage(event.data as T)
    }
  }

  window.addEventListener('message', handleMessage)

  return () => {
    window.removeEventListener('message', handleMessage)
  }
}
